<template>
  <div :class="['app-container', `lang-${lang}`]">
    <CmHeader />
    <router-view />
    <CmFooter />
    <FloatContact />
    <CommCss />
  </div>
</template>

<script>
    import { onMounted, watch } from 'vue' // 新增：引入watch
    import { useRoute } from 'vue-router' // 新增：引入路由钩子
    import CmHeader from '@/components/common/header.vue'
    import CmFooter from '@/components/common/footer.vue'
    import { useLang } from '@/composables/useLang'
    import FloatContact from '@/components/common/FloatContact.vue'
    import CommCss from '@/components/common/CommCss.vue'

  // 新增：1. 定义多语言meta配置（关键字/描述固定，标题按页面分）
  const metaConfig = {
    keywords: {
        zh: '社交媒体营销|社交媒体推广|社交媒体运营|社交媒体管理|小红书代运营|抖音代运营|领英澳维',
        en: 'Social Media Marketing|Social Media Promotion|Social Media Operation|Social Media Management|Xiaohongshu Operation|TikTok Operation|LinkedIn Operation'
    },
    // 固定的描述（中英文）
    description: {
        zh: '领英澳维专注全球数字营销与社媒推广，专注企业品牌传播、线上曝光与客户触达，提供贴合市场、可落地的推广解决方案。',
        en: 'Always Creative specializes in global digital marketing and social media promotion, focusing on corporate brand communication, online exposure and customer reach, providing market-adapted and implementable promotion solutions.'
    },
    // 各页面的标题（中英文）
    pageTitles: {
        home: {
        zh: '首页 - 领英澳维',
        en: 'Home - Always Creative'
        },
        service: {
        zh: '营销服务 - 领英澳维',
        en: 'Service - Always Creative'
        },
        about: {
        zh: '关于我们 - 领英澳维',
        en: 'About - Always Creative'
        },
        news: {
        zh: '新闻动态 - 领英澳维',
        en: 'News - Always Creative'
        },
        contact: {
        zh: '联系我们 - 领英澳维',
        en: 'Contact - Always Creative'
        },
        // 新增页面只加这里即可
        default: {
        zh: '领英澳维 - 助力品牌增长',
        en: 'Always Creative - Media Account Operation - Boost Brand Growth'
        }
    }
  }

  // 新增：2. 封装meta设置函数
  const setPageMeta = (lang, pageKey) => {
    // 设置关键字
    const keywordsMeta = document.querySelector('meta[name="keywords"]') || document.createElement('meta')
    keywordsMeta.setAttribute('name', 'keywords')
    keywordsMeta.setAttribute('content', metaConfig.keywords[lang] || metaConfig.keywords.zh)
    if (!document.querySelector('meta[name="keywords"]')) document.head.appendChild(keywordsMeta)

    // 设置描述
    const descMeta = document.querySelector('meta[name="description"]') || document.createElement('meta')
    descMeta.setAttribute('name', 'description')
    descMeta.setAttribute('content', metaConfig.description[lang] || metaConfig.description.zh)
    if (!document.querySelector('meta[name="description"]')) document.head.appendChild(descMeta)

    // 设置标题（动态）
    const pageTitle = metaConfig.pageTitles[pageKey] || metaConfig.pageTitles.default
    document.title = pageTitle[lang] || pageTitle.zh
  }

  export default {
    name: 'App',
    components: {
      CmHeader,
      CmFooter,
      FloatContact,
      CommCss
    },
    setup() {
      const { lang, watchLangChange } = useLang()
      const route = useRoute() // 新增：获取当前路由

      // 原有逻辑：语言切换监听
      const handleLangChange = () => {
        console.log('当前语言切换为：', lang.value)
        // 新增：语言切换时更新meta
        setPageMeta(lang.value, route.meta.pageKey)
      }
      watchLangChange(handleLangChange)

      // 新增：3. 监听路由变化更新meta（标题随页面变）
      watch(route, (newRoute) => {
        setPageMeta(lang.value, newRoute.meta.pageKey)
      }, { immediate: true }) // immediate：初始化时立即执行

      onMounted(() => {
        console.log('App初始化语言：', lang.value)
        // 新增：初始化时设置一次meta
        setPageMeta(lang.value, route.meta.pageKey)
      })

      return {
        lang
      }
    }
  }
</script>

<style lang="scss">
  
</style>